import { useIntl } from 'react-intl';

export const useTranslator = (prefix = '') => {
  const { formatMessage } = useIntl();
  const getId = (id) => (prefix ? `${prefix}.${id}` : id);
  const translate = (id, objects = {}) => formatMessage({ id: getId(id) }, objects);
  return { translate };
};
